import React from 'react'

import { EuiSpacer } from '@elastic/eui'

import { MasterCampaignPlanCustomSection } from 'api/interfaces/MasterCampaignPlan'

import CustomizableSection from '../ExecutiveSummary/CustomizableSection'

export interface RenderCustomSectionsProps<T> {
  sections: MasterCampaignPlanCustomSection[] | undefined
  position: T
  editMode: boolean
  onEdit: (position: T, index: number) => void
  onDelete: (position: T, index: number) => void
}

export function RenderCustomSections<T>({ sections, position, editMode, onEdit, onDelete }: RenderCustomSectionsProps<T>) {
  if (!sections || sections.length === 0) {
    return null
  }

  return (
    <>
      {sections.map((section, index) => (
        <React.Fragment key={index}>
          <CustomizableSection section={section} defaultTitle='' defaultContent='' defaultShowTitle={true} separator='spacer' onEdit={() => onEdit(position, index)} onDelete={() => onDelete(position, index)} showActions={editMode} />
          <EuiSpacer size='xl' />
        </React.Fragment>
      ))}
    </>
  )
}
